import React from 'react';

interface IconAngleDownProps {
    iconClasses?: string;
}

const IconAngleDown: React.FC<IconAngleDownProps> = ({ iconClasses }) => {
    return (
        <svg
            width="25"
            height="13"
            viewBox="0 0 25 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-angle-down ${iconClasses ?? ''}`}
        >
            <path d="M22.5 0L25 2.16664L12.5001 13L0 2.16664L2.49999 0L12.5001 8.66671L22.5 0Z" fill="currentColor" />
        </svg>
    );
};

export default IconAngleDown;
